// Gait stores a retired application as REVOKED; customers see "Retired"
// (the action they took), matching the docs.
export const APPLICATION_STATUS_LABELS = {
    ACTIVE: "Active",
    SUSPENDED: "Suspended",
    REVOKED: "Retired",
};

export const CREDENTIAL_STATUS_LABELS = {
    ACTIVE: "Active",
    REVOKED: "Revoked",
};
